<template>
  <button
    type="button"
    :class="`c-button btn btn-info btn-${size} ${className}`"
    :data-beacon-article-modal="link"
    data-toggle="tooltip"
    title="Show help page for this tab"
  >
    <i class="fa-regular fa-question-square"></i> Help
  </button>
</template>

<script>
export default {
  props: {
    link: {
      type: String,
      default: ''
    },
    className: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: 'sm'
    }
  }
}
</script>

<style lang="scss" scoped>
.btn {
  &:disabled {
    cursor: not-allowed;
  }
}

.c-button {
  position: relative;
}
</style>